import { supabase } from './client';

export interface DriveReportMetadata {
  /** Nếu có → UPDATE record thay vì INSERT (dùng khi thay thế file khi chỉnh sửa) */
  report_id?: string;
  id_group?: string;
  id_team?: string;
  period?: string;
  report_name?: string;
  summary?: string;
  report_date?: string;
  auth_user_id?: string;
  /** Đồng bộ với auth_user_id khi ghi DB */
  user_id?: string;
  created_by_user_id?: string;
  is_summary?: boolean;
}

export interface DriveUploadResponse {
  success: boolean;
  message: string;
  data?: {
    report_id: string;
    full_url: string;
    file_id: string;
  };
  error?: string;
}

const STAGING_BUCKET = 'drive-staging';

/**
 * Upload a file to the drive-staging bucket.
 * Returns the storage path to pass to the Edge Function.
 */
export async function uploadFileToStaging(file: File): Promise<string> {
  const ext = file.name.split('.').pop() || 'bin';
  const timestamp = Date.now();
  const storagePath = `uploads/${timestamp}_${crypto.randomUUID().substring(0, 8)}.${ext}`;

  const { error } = await supabase.storage
    .from(STAGING_BUCKET)
    .upload(storagePath, file, {
      contentType: file.type || 'application/octet-stream',
      upsert: false,
    });

  if (error) {
    throw new Error(`Failed to upload file to staging: ${error.message}`);
  }

  return storagePath;
}

/**
 * Call the upload-to-drive Edge Function with the staged file path and metadata.
 * The Edge Function downloads from staging, uploads to Google Drive, saves to DB.
 */
export async function createDriveReport(
  storagePath: string,
  fileName: string,
  fileType: string,
  metadata: DriveReportMetadata
): Promise<DriveUploadResponse> {
  const { data, error } = await supabase.functions.invoke('upload-to-drive', {
    body: {
      storage_path: storagePath,
      file_name: fileName,
      file_type: fileType,
      ...metadata,
    },
  });

  if (error) {
    // Extract actual error message from Edge Function response body
    let realMessage = error.message || 'Edge Function call failed';
    try {
      // FunctionsHttpError exposes raw Response via .context
      const body = await (error as any).context?.json?.();
      if (body?.error) realMessage = body.error;
    } catch (_) { /* ignore parse errors */ }
    throw new Error(realMessage);
  }

  return data as DriveUploadResponse;
}
